/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Microsoft_Tenant_RemoveInputs */



/**
* | output |
* | --- |
* | "Remove restriction" |
*
* @param {Microsoft_Tenant_RemoveInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const microsoft_tenant_remove = /** @type {((inputs?: Microsoft_Tenant_RemoveInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Microsoft_Tenant_RemoveInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einschränkung aufheben")
	return /** @type {LocalizedString} */ ("Remove restriction")
});